import { Component } from '@angular/core';
import {NavController} from '@ionic/angular';
import { NearbyEventNew, ParticipantSearchListModel } from '../../../providers/event/event';
import { Router } from '@angular/router';

/**
 * Generated class for the NearbyEventParticipantsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


/*
  ATTENTION!
  This page is no longer used from build 1.1.94.
  The component is merged into NearbyEventParticipantSearch
*/

@Component({
  selector: 'page-nearby-event-participants',
  templateUrl: 'nearby-event-participants.html',
  styleUrls:['./nearby-event-participants.scss']
})
export class NearbyEventParticipantsPage {

  activeItem: NearbyEventNew;
  constructor(
    public navCtrl: NavController, 
    public router:Router
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    this.activeItem = state['activeItem'];
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter NearbyEventParticipantsPage');

  }

  remove(participant: ParticipantSearchListModel) {
    this.activeItem.participants.splice(
      this.activeItem.participants.findIndex(x => x.lid === participant.lid)
      , 1);
  }

  showSearch() {
    this.navCtrl.navigateForward('/nearby-event-participant-search', {state:{activeItem: this.activeItem}});
    // (this.app.getRootNav() as NavController).push(NearbyEventParticipantSearchPage, { activeItem: this.activeItem });

  }



}
